import React from 'react';
import PropTypes from 'prop-types';

function CheckFillIcon({ color = 'black', width = 18, height = 18, ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.99935 17.3337C4.39685 17.3337 0.666016 13.6028 0.666016 9.00033C0.666016 4.39783 4.39685 0.666992 8.99935 0.666992C13.6018 0.666992 17.3327 4.39783 17.3327 9.00033C17.3327 13.6028 13.6018 17.3337 8.99935 17.3337ZM8.16852 12.3337L14.0602 6.44116L12.8819 5.26283L8.16852 9.97699L5.81102 7.61949L4.63268 8.79783L8.16852 12.3337Z"
        fill={color}
      />
    </svg>
  );
}

CheckFillIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default CheckFillIcon;
